import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var VolumeMuteIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M12 4.414a2 2 0 011.995 1.851l.005.15v11.17a2 2 0 01-3.287 1.532L10.586 19l-3-3H5a2 2 0 01-1.995-1.85L3 14v-4a2 2 0 011.85-1.995L5 8h2.586l3-3A2 2 0 0112 4.414zm0 2L8.707 9.707a1 1 0 01-.576.284L8 10H5v4h3a1 1 0 01.608.206l.1.087L12 17.586V6.414zm4.613 2.796l.094.083L18 10.585l1.293-1.292a1 1 0 011.414 1.414L19.414 12l1.293 1.294a1 1 0 01-1.32 1.497l-.094-.083L18 13.414l-1.293 1.293a1 1 0 01-1.414-1.414l1.292-1.294-1.292-1.292a1 1 0 011.32-1.497z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
VolumeMuteIcon.isCarinaIcon = true;
export default VolumeMuteIcon;
